import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, of, Subject, throwError } from 'rxjs';
import { catchError, filter, map, switchMap, take, tap } from 'rxjs/operators';
import { Collection, Logout, Training } from '../app.urls';
@Injectable({
  providedIn: 'root',
})
export class CollectionService {
  public addColuser = new Subject<any>();
  private newCollection = new BehaviorSubject<any>('');
  public getNewCollectionData = this.newCollection.asObservable();
  onBackStyleGroupDetails = new BehaviorSubject<any>(false);

  private refreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  
  addCollectionuser(value: any) {
    this.addColuser.next(value);
  }
  constructor(private http: HttpClient, private router: Router) { }

  newCollectionList(collection: any) {
    this.newCollection.next(collection);
  }

  //  this function is fetching languages data from api
  getLanguages(): Observable<any> | null {
    // const apiUrl = environment.apiUrl + 'MasterResource/languages';
    return this.http.get<any>(Collection.Language);
  }

  // this function is fetching time zones data from api
  getTimeZone(): Observable<any> | null {
    return this.http.get<any>(Collection.TimeZone);
  }

  //  this function is posting collection data to api
  postCollection(userForm: any): Observable<any> | null {
    return this.http.post<any>(Collection.Clients, userForm);
  }

  refershToken(): Observable<any> | null {
    if (sessionStorage.getItem('currentUser')) {
      const currentUserFromStorage = JSON.parse(
        sessionStorage.getItem('currentUser') || '{}'
      );
      const accessTokenFromStoarge = currentUserFromStorage['accessToken'];
      const accessrefreshTokenFromStoarge = currentUserFromStorage['refreshToken'];
      const headers = {
        'content-type': 'application/json',
        token: accessTokenFromStoarge,
        refreshToken: accessrefreshTokenFromStoarge,
        TimezoneOffset: this.getTimezoneOffset(),
      };
      const apiUrl = Collection.Refresh;
      return this.http.get<any>(apiUrl, { headers: headers }).pipe(
        tap((user: any) => {
          if (user && user.data) {
            sessionStorage.setItem('currentUser', JSON.stringify(user.data))
          }
        })
      );
    } else {
      return null;
    }
  }


  getNewAccessToken(): Observable<any> {
    if (!this.refreshing) {
      this.refreshing = true;
      this.refreshTokenSubject.next(null);

      return this.refershToken().pipe(
        switchMap((res: any) => {
          this.refreshing = false;
          this.refreshTokenSubject.next(res.data);
          return of(res.data);
        }),
        catchError((error) => {
          this.refreshing = false;
          return throwError(error);
        })
      );
    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1)
      );
    }
  }

  //This function is used for only search filter on collection landing page
  getCollectionFilter(item: any): Observable<any> | null {
    const fetchCollectionApiUrl = Collection.Clients + '?searchText=' + item.searchText
    return this.http.get<any>(fetchCollectionApiUrl);
  }

  //  this function is get all collection data from api
  getCollection(): Observable<any> | null {
      //const apiUrl = environment.apiUrl + 'clients/' + clientId + '/collections';
      // const apiUrl = environment.apiUrl + 'CollectionResource/clients/collections';
    return this.http.get<any>(Collection.Clients);
  }
  // this function is used registering new client for tanay assessment
  registerClient(clientForm: any): Observable<any> | null {
    return this.http.post<any>(Collection.Mundrisoft, clientForm);
  }

  // this function is get all collection users data from api
  getCollectionUsers(collectionId: any): Observable<any> | null {
    return this.http.get<any>(Collection.CollectionUser + collectionId);
  }

  getCollectionDetails(collectionId: any): Observable<any> | null {
    return this.http.get<any>(Collection.CollectionDetails + collectionId)
  }

  getRoleList() {
    return this.http.get<any>(Collection.RoleList);
  }
  getUserRoles() {
    return this.http.get<any>(Collection.UserRole)
  }

  // this function is used for search collection users
  getCollectionUserSearch(searchParams) {
    if (sessionStorage.getItem('currentUser')) {
      const collectionId = JSON.parse(
        sessionStorage.getItem('defaultcollectionuuid') || '{}'
      );
      const apiUrl = Collection.CollectionUser + collectionId + '?' + 'firstName=' + searchParams.firstName + '&' + 'lastName=' + searchParams.lastName + '&' + 'role=' + searchParams.role + '&' + 'status=' + searchParams.status;
      return this.http.get<any>(apiUrl)
    } else {
      return null;
    }
  }

  UpdateCollectionDetails(collectionuuId, formValue) {
    const dataToApi = {
      collectionName: formValue.collectionName,
      description: formValue.description,
      langid: formValue.langid,
      // timezoneid: formValue.timezoneid,
      timezoneName: formValue.timezoneName,
    };
    return this.http.put<any>(Collection.UpdateCollection + collectionuuId, dataToApi)
  }

  UpdateUserRole(usertoUpdate, collectionUserId) {
    return this.http.put<any>(Collection.CollectionUser + collectionUserId, usertoUpdate)
  }

  addUsertoCollection(addUsertoCollection) {
    return this.http.post<any>(Collection.AddUserToCollection, addUsertoCollection)
  }

  deleteUserfromCollection(collectionuuId, collectionUseruuId): Observable<any> {
      // /collectionuser/{collectionId}/{collectionUserId}
    return this.http.delete<any>(Collection.CollectionUser + collectionuuId + '/' + collectionUseruuId)
  }

  getTimezoneOffset(): string {
    return (String(new Date().getTimezoneOffset()))
  }

  //style group api's
  getStyleGroups(globalcollectionuuId) {
    return this.http.get<any>(Collection.CollectionDetails + globalcollectionuuId + '/style-group-list');
  }

  //This API for style-group filter
  getFilterStyleGroup(items: any, globalcollectionuuId): Observable<any> | null {
    const FetchStyleGroupApi = Collection.CollectionDetails + globalcollectionuuId + '/style-group-list' + '?styleGroupName=' + items.styleGroupName +  '&styleName=' + items.styleName
    return this.http.get<any>(FetchStyleGroupApi);
  }

  addNewStyleGroup(globalcollectionuuId, payload) {
    return this.http.post<any>(Collection.CollectionDetails + globalcollectionuuId + '/style-group', payload);
  }

  updateStyleGroup(globalcollectionuuId, payload) {
    return this.http.put<any>(Collection.CollectionDetails + globalcollectionuuId + '/style-group', payload);
  }

  deleteStyleGroup(globalcollectionuuId, styleGroupId): Observable<any> {
    return this.http.delete<any>(Collection.CollectionDetails + globalcollectionuuId + '/style-group/' + styleGroupId);
  }

  getStyleGroupDetails(globalcollectionuuId, styleGroupId) {
    return this.http.get<any>(Collection.CollectionDetails + globalcollectionuuId + '/style-group/' + styleGroupId);
  }

  getStyleList(globalcollectionuuId, styleGroupId) {
    return this.http.get<any>(Collection.CollectionDetails + globalcollectionuuId + `/style-list/${styleGroupId}`);
  }

  createNewStyle(styleGroupId, payload) {
    return this.http.post<any>(Collection.CollectionDetails + `${styleGroupId}/style`, payload);
  }

  updateStyle(styleGroupId, payload) {
    return this.http.put<any>(Collection.CollectionDetails + `${styleGroupId}/style`, payload);
  }

  deleteStyle(styleGroupId, styleId) {
    return this.http.delete<any>(Collection.CollectionDetails + `${styleGroupId}/style/${styleId}`);
  }

  getStyleDetails(styleGroupId, styleId) {
    return this.http.get<any>(Collection.CollectionDetails + `${styleGroupId}/style/${styleId}`);
  }

  expireToken(id, uuid) {
    return this.http.post<any>(Logout.logout + id + `?loginUuid=${uuid}`, null)
  }

  videoTutorial(assetGroup) {
    return this.http.get<any>(Training.tutorial + assetGroup);
  }
}
